import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const languages = [
  { code: 'en', name: 'English', subtitle: 'ENGLISH', flag1: '🇺🇸', flag2: '🇬🇧' },
  { code: 'ar', name: 'العربية', subtitle: 'ARABIC', flag1: '🇸🇦', flag2: '🇦🇪' },
  { code: 'fr', name: 'Français', subtitle: 'FRENCH', flag1: '🇫🇷', flag2: '🇨🇦' }
];

const LanguageSection = () => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <section className="py-16 md:py-24 bg-[#1a1f2e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Globe className="w-8 h-8 text-[#d4a33a]" />
            <h2 className="text-3xl md:text-4xl font-bold text-white">{t('selectLanguage')}</h2>
          </div>
          <p className="text-gray-400 text-lg">
            {t('selectLanguageDesc')}
          </p>
        </div>

        {/* Language Cards with Glowing Frame */}
        <div className="flex flex-wrap justify-center gap-6">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => setLanguage(lang.code)}
              className={`relative w-52 p-6 rounded-xl transition-all duration-500 ${
                language === lang.code
                  ? 'bg-[#2a3142]'
                  : 'bg-[#232836] hover:bg-[#2a3142]'
              }`}
              style={{
                boxShadow: language === lang.code 
                  ? '0 0 30px rgba(212, 163, 58, 0.5), 0 0 60px rgba(212, 163, 58, 0.3), inset 0 0 20px rgba(212, 163, 58, 0.1)' 
                  : 'none',
                border: language === lang.code 
                  ? '2px solid #d4a33a' 
                  : '2px solid transparent'
              }}
            >
              {/* Animated glow effect for selected */}
              {language === lang.code && (
                <div 
                  className="absolute inset-0 rounded-xl pointer-events-none"
                  style={{
                    background: 'linear-gradient(45deg, transparent, rgba(212, 163, 58, 0.1), transparent)',
                    animation: 'glow-pulse 2s ease-in-out infinite'
                  }}
                />
              )}
              
              <div className="relative z-10">
                <div className="flex justify-center gap-2 mb-4">
                  <span className="text-4xl">{lang.flag1}</span>
                  <span className="text-4xl">{lang.flag2}</span>
                </div>
                <h3 className={`font-semibold text-lg mb-1 ${language === lang.code ? 'text-[#d4a33a]' : 'text-white'}`}>
                  {lang.name}
                </h3>
                <p className="text-gray-400 text-sm uppercase tracking-wide">{lang.subtitle}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* CSS for glow animation */}
      <style>{`
        @keyframes glow-pulse {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
      `}</style>
    </section>
  );
};

export default LanguageSection;
